<template lang="pug">
label.v-field-custom-checkbox.field-custom-checkbox(:class="{'field-custom-checkbox--radio': radio, 'field-custom-checkbox--disabled': disabled}")
	input.field-custom-checkbox__input(
		:type="radio ? 'radio' : 'checkbox'"
		:value="trueValue"
		v-model="localValue"
		@change="handleInput"
		@click="handleClick"
		:disabled="disabled"
		:aria-labelledby="(labelId ? labelId + ' ' + uniqueId : null)"
		:id="uniqueId")
	.field-custom-checkbox__card(v-if="item" )
		.field-custom-checkbox__visual
		.field-custom-checkbox__body
			.field-custom-checkbox__title(v-if="item.title" ) {{ item.title }}
			.field-custom-checkbox__category-note(v-if="item.categoryNote")
				span {{ item.categoryNote }}
				a.field-custom-checkbox__category-link(v-if="item.categoryLink"
					:href="item.categoryLink"
					target="_blank"
					rel="noopener"
					@click.stop) {{ item.categoryLinkText }}
			.field-custom-checkbox__info
				.field-custom-checkbox__info-left
					.field-custom-checkbox__boxed-text(v-if="item.text" ) {{ item.text }}
					template(v-if="item.fields" )
						.field-custom-checkbox__field(v-for="(field, index) in item.fields" :key="index" )
							v-field(:field="{...field, disabled: localValue !== trueValue }" :model-value="field.value" @update:model-value="fieldHandler" )
					ul.field-custom-checkbox__items(v-if="item.items" )
						li.field-custom-checkbox__item(v-for="(li, index) in item.items" :key="index" ) {{ li.text }}
					.field-custom-checkbox__reservation-note(v-if="item.note") {{ item.note }}
				.field-custom-checkbox__info-right
					template(v-if="item.image")
					img.field-custom-checkbox__image(
						:src="item.image?.src"
						:alt="item.image?.alt")

</template>

<script>
import uniqueId from '../scripts/helpers/uniqueId.js';

export default {
	props: {
		radio: {
			type: Boolean,
			default: false
		},

		item: {
			type: Object,
			default: null
		},

		modelValue: {
			type: [Object, String, Number, Boolean],
			default: null
		},

		trueValue: {
			type: [Object, String, Number, Boolean],
			default: null
		},

		disabled: {
			type: Boolean,
			default: false
		},

		labelId: {
			type: String,
			default: null
		}
	},

	emits: [
		'update:model-value'
	],

	data() {
		return {
			localValue: null,
			open: false,
			priceValue: '',
			uniqueId: uniqueId('field-')
		};
	},

	watch: {
		modelValue() {
			this.updateLocalValue();
		},
	},

	created() {
		this.updateLocalValue();
		if(this.localValue === this.trueValue) {
			this.item.fields.find(field => field.key === 'price').value = this.priceValue
		} else {
			this.priceValue = this.modelValue?.price
		}
	},

	methods: {
		updateLocalValue() {
			this.localValue = this.modelValue?.status || this.modelValue;
			this.priceValue = this.modelValue?.price

		},

		fieldHandler(value) {
			this.priceValue = value;
			if(this.localValue === this.trueValue) {
				this.$emit('update:model-value', {
					'status':  this.localValue,
					'price': this.priceValue
				});
			}
		},

		handleClick() {
			if(this.localValue === this.trueValue) {
				this.$emit('update:model-value', null);
			}
		},

		handleInput() {
			this.priceValue = this.item?.fields ? this.item?.fields.find(field => field.key === 'price').value : null

			this.$emit('update:model-value', {
				'status':  this.localValue,
				'price': this.priceValue
			});
		}
	},

	// computed: {
	// 	computedText() {
	// 		if(this.number || this.number === 0) {
	// 			if(this.number === 0) {
	// 				return `<span class="c-gray">${this.text}<span class="field-custom-checkbox__number c-gray">${this.number}</span></span>`
	// 			}
	// 			return `${this.text}<span class="field-custom-checkbox__number">${this.number}</span>`
	// 		}
	// 		return this.text
	// 	}
	// }
};
</script>
